import { render, staticRenderFns } from "./NCCorrectiveActionVIew.vue?vue&type=template&id=5af22b90&scoped=true"
import script from "./NCCorrectiveActionVIew.vue?vue&type=script&lang=js"
export * from "./NCCorrectiveActionVIew.vue?vue&type=script&lang=js"
import style0 from "./NCCorrectiveActionVIew.vue?vue&type=style&index=0&id=5af22b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af22b90",
  null
  
)

export default component.exports